import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';
import type { ReactNode} from 'react';
import { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

interface LayoutProps {
    children: ReactNode;
    title?: string;
    actions?: ReactNode;
}

export function Layout({ children, title, actions }: LayoutProps) {
    const { user } = useAuth();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    // If no user, render children without layout (for login page)
    if (!user) {
        return <>{children}</>;
    }

    return (
        <div className="min-h-screen bg-background">
            {/* Sidebar */}
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
                isCollapsed={isSidebarCollapsed}
                onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            />

            {/* Topbar */}
            <Topbar
                onMenuClick={() => setIsSidebarOpen(true)}
                title={title}
                actions={actions}
                isSidebarCollapsed={isSidebarCollapsed}
            />

            {/* Main content */}
            <main className={cn(
                "pt-16 min-h-screen transition-all duration-300 ease-out-expo",
                "lg:pl-64",
                isSidebarCollapsed && "lg:pl-20"
            )}>
                <div className="main-content animate-fade-in">
                    {children}
                </div>
            </main>
        </div>
    );
}

export default Layout;
